import React from 'react';
import BarStatsComponent from './../Components/BarStatsComponent.jsx';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectReason } from './../actions/index.js';
import { colours } from './..//helpers';
import { scenario as scenariosSelectors } from './../selectors';

const RegressionBarStatsContainer =
  ({ scenariosByReason, onClick }) => {
    const series = Object.keys(scenariosByReason).map(reason => {
      return { label: reason, colour: colours.colours.red };
    });
    const barData = series.map(s => scenariosByReason[s.label].length);

    const chart =
      <Col md={12} style={{ 'marginBottom': '30px' }} >
        <BarStatsComponent
          style={'warning'} barData={barData} onClick={onClick}
          title={'Failure Reason Chart'} series={series}
          yMax={Math.ceil((Math.max(...barData) / 100)) * 100}
        />
      </Col>;

    return (
      <div>
        {chart}
      </div>
    );
  };

RegressionBarStatsContainer.propTypes =
{
  scenariosByReason: PropTypes.objectOf(PropTypes.array).isRequired,
  onClick: PropTypes.func.isRequired
};

export const mapStateToProps = (state) => {
  const scenariosByReason = scenariosSelectors
    .regressionFailureTrendsScenariosByReason(state);

  const props = { scenariosByReason };
  return props;
};

export const mapDispatchToProps = (dispatch) => {
  return { onClick: (chart) => dispatch(selectReason(chart)) };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegressionBarStatsContainer);


// WEBPACK FOOTER //
// src/Containers/RegressionBarStatsContainer.jsx